import { render, staticRenderFns } from "./ReferralItem.vue?vue&type=template&id=a299cf72&scoped=true&"
import script from "./ReferralItem.vue?vue&type=script&lang=js&"
export * from "./ReferralItem.vue?vue&type=script&lang=js&"
import style0 from "./ReferralItem.vue?vue&type=style&index=0&id=a299cf72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a299cf72",
  null
  
)

export default component.exports